//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import UserInfoModule from '../content/settings/user-infocard';

import { UserForm } from "../services/srvc-utilities";

export default function Settings() {

  return (
  <>
    <ContentFormatXX 
      head='Settings'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <UserInfoModule />

        </>
      } 
    />
  </>
  )
}